<!--
 * @Author: guoyu
 * @Date: 2020-12-01 18:31:14
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-04 15:00:07
 * @Description: 行数可控的文本组件
-->
<template>
  <div>
    <div
      class="text-container"
      :class="{ 'is-over': this.isOver && !this.showAll }"
      :style="textStyle"
    >
      <slot></slot>
      <div class="line-get-container" ref="h">.</div>
    </div>
    <div class="handle-button" v-if="isOver" @click="showAll = !showAll">
      {{ showAll ? $t('upgrade_page_layout_nav_52') : $t('upgrade_page_views_home_index_3') }}
      <i :class="showAll ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rows: {
      type: [String, Number],
      default: 2
    }
  },
  data() {
    return {
      isOver: false,
      showAll: false,
      lHeight: 0
    };
  },
  computed: {
    textStyle() {
      return this.isOver && !this.showAll
        ? {
            '-webkit-line-clamp': this.rows,
            overflow: 'hidden',
            height: this.rows * this.lHeight + 'px'
          }
        : {};
    }
  },
  methods: {
    computedRealHeight() {
      let lineHeight = this.$refs.h.clientHeight;
      let cHeight = this.$el.clientHeight;
      let tRows = parseInt(cHeight / lineHeight);
      this.lHeight = lineHeight;
      if (tRows > this.rows) {
        this.isOver = true;
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.computedRealHeight();
    }, 500);
  }
};
</script>
<style lang="scss" scoped>
.text-container {
  position: relative;
  text-overflow: ellipsis;
}
.is-over {
  &::after {
    content: '...';
    position: absolute;
    bottom: 0px;
    right: 0;
    padding: 0 5px;
    background-color: #fff;
  }
}
.line-get-container {
  position: absolute;
  top: -99999px;
}
.handle-button {
  margin-top: 4px;
  text-align: left;
  font-weight: 500;
  cursor: pointer;
}
</style>
